import mapHandler from '../custom/components/map'

function renderNewContent(newElements, containerContent, containerNoPosts, containerSection) {
    containerNoPosts.addClass('d-none');
    containerSection.addClass('wrap-bottom');
    var $newElements = newElements.css({
        opacity: 0
    });
    containerContent.html($newElements);
    newElements.animate({
        opacity: 1
    });


}
function showSearchResultAmount(){
    $('.centres-search-results').addClass('is-active');
    $('.centres-sidebar').addClass('is-active');
}
function showNoContentContainer (container, containerNoPosts) {
    container.html('');
    containerNoPosts.removeClass('wrap-bottom');
    containerNoPosts.removeClass('d-none');
}
function hideNoContentContainer (container, containerNoPosts) {
    container.html('');
    containerNoPosts.addClass('wrap-bottom');
    containerNoPosts.addClass('d-none');
}

function getLocations() {
    var locations = [];
    [...document.querySelectorAll('.b-centre-title')].forEach((center) => {
        let lat = Number(center.getAttribute('data-centre-latitude'));
        let lng = Number(center.getAttribute('data-centre-longitude'));
        let obj = {lat:lat, lng:lng };
        locations.push(obj);
    });
    return locations;
}
function getLocationID () {
    return $('#search-hidden-location-input').val();
}
function transformLocations (array) {
    return array.map(function(item) {
        let lng = item.location.lng[0];
        let lat = item.location.lat[0];
        let LatLng = {lat:lat,  lng:lng};
        return LatLng;
    });
}
function getAutocompleteListOrLocationId (filterArchive) {
        var searchDropdown = $('.archive-search-dropdown');
    var searchDropdownList = $('.archive-search-dropdown-list');
    var searchDropdownError = $('.archive-search-dropdown-error');
    var filterArchive = filterArchive;
    $('.loading').addClass('is-active');
    var url = window.location.origin + '/wp-content/api/autocomplete.php';

    $.ajax({
        type: 'GET',
        url: url,
        dataType: 'html',
        data: {
            'action': 'sfw_get_centres_autocomplete',
            'post_type': SkillsForWales.post_type,
            'search_query': $('#search-query').val(),
            'site_url':$('#search-query').attr('data-url')
        },
        success: function(data) {
            $('.loading').removeClass('is-active');
            var response = $.parseJSON(data);
            var $data = $(response.data[0].suggestions);


            if(!filterArchive.isNeedToGetOnlyAutocompleteResults) {
                console.log('getting autocompete list');
                //TODO optimization
                searchDropdownList.html('');
                searchDropdown.addClass('is-active');
                searchDropdownList.show();
                searchDropdownError.hide();
                if ($data.length) {
                    $.each($data, function (key, value) {
                        var rowElement = $("<li></li>", { 'class': 'archive-search-dropdown-item', 'text': $data[key].text, 'data-centre-id': $data[key].id, 'data-centre-url': $data[key].url });
                        rowElement.appendTo(searchDropdownList);
                    });
                    $('#search-hidden-location-input').val($data[0].id);
                } else {
                    searchDropdownList.hide();
                    searchDropdownError.show();
                    var isError = $("div").is(".archive-search-dropdown-error");
                    if(!isError) {
                        var rowElement = $("<div></div>", { 'class': 'archive-search-dropdown-error', 'text': 'Please, try another search'});
                        rowElement.appendTo(searchDropdown);
                    }

                }

            } else {
                console.log('getting id from autocompete list');
                filterArchive.filterGetListAjax($data[0].id);
                filterArchive.isNeedToGetOnlyAutocompleteResults = false;
                $('#search-hidden-location-input').val($data[0].id);
            }

        },
        error: function(jqXHR, textStatus, errorThrown) {
            $('.loading').removeClass('is-active');
            console.log($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
        },
    });
}

jQuery(function($) {
    // SkillsForWales is required to continue
    if (typeof SkillsForWales === 'undefined' || typeof multiSelect === 'undefined') {
        return false;
    }







    /**
     * Object to handle the filter archive UI.
     */

    var filterArchive = {

        timeout: null,
        archiveMultiSelects: false,
        archiveNoPosts: $('.section-no-posts'),
        archiveLoadMore: $('#load-more'),
        archivePostType: SkillsForWales.post_type,
        archiveSection: false,
        archiveContent: false,
        archiveOffset: false,
        archiveClearAll: false,
        archivePerPage: 3,
        archiveSectionContent: $('.centres-content'),



        /**
         * Initialize filter archive UI events
         */
        mapIni: function () {
            if($('.section-centres').length) {
                var locations = getLocations();

                this.centresMap = new mapHandler($('.section-centres'));
                this.centresMap.initMap();
                this.centresMap.drawMarkers(locations, this.centresMap.getMap());

            }
        },
        init: function() {

            // Set the archive vars
            this.archiveSection = $('.section-' + this.archivePostType + 's');
            this.isNeedToGetOnlyAutocompleteResults = false;
            this.isCheckedBox = false;
            this.isCentresPage = !!(this.archiveSection.hasClass('section-centres'));
            this.isQulificationPage = !!($(document.body).hasClass('single-qualification'));
            this.mapIni();

            this.archiveContent = this.archiveSection.find('.row:first');
            this.archiveOffset = this.archiveContent.find('.' + this.archivePostType).length;

            var urlSearch = window.location.search;
            if(urlSearch!="") {
                const urlParams = new URLSearchParams(urlSearch);
                const centerId = urlParams.get('center_id');
                const qualificationIds = urlParams.get('qualification_ids');
                if(centerId) {
                    filterArchive.filterGetListAjax(centerId, qualificationIds);
                }
            }


            // Get the multiselects
            this.archiveMultiSelects = this.getMultiSelects();

            // Search input handler
            $(document.body).on('input', '#search-query', this.handleSearchInput);

            $('#submit-arrow').bind('click', {msg:this.archivePostType}, this.handleSearchInputBtn);

            $(document.body).on('change', 'input.checkedbox', this.handleSortByOptions);
            // Search input autocomplete hints handler
            $(document.body).on('click', '.archive-search-dropdown-item', this.handleAutocomplete);

            // Ajax archive filter
            $('.multiselect').on('apply', this.handleCheckedBox);

            // Handle the clear all state
            $('.multiselect').on('apply', this.handleClearAll);

            $(document.body).on('change', 'input.checkedbox', this.handleCheckedBox);

            $(document.body).on('change', 'input.checkedbox', this.handleClearAll);

            $(document.body).click(this.hideDropdownOnClickOutside);

        },
        hideDropdownOnClickOutside: function (e) {
            var $target = $(e.target);
            if(!$target.closest('.archive-search-dropdown-item').length &&
                $('.archive-search-dropdown').is(":visible")) {
                $('.archive-search-dropdown').removeClass('is-active');
            }
        },

        /**
         * Get all multiselects in the form.
         */
        getMultiSelects: function() {
            filterArchive.archiveMultiSelects = multiSelect.multiSelectForm.find('.multiselect, .singleselect').not('.multiselect-single');
            return filterArchive.archiveMultiSelects;
        },

        /**
         * Handle the sort by options.
         */
        handleSortByOptions: function(evt) {
            var sortByList = $(this).closest('ul');
            var sortBy = $(this);
            sortByList.find('input[type^=checkbox]').not(this).each(function() {
                $(this).prop('checked', false);
            });
            $('#sort_by').find('.title span').text(sortBy.val());
        },

        handleCheckedBox: function() {
            clearTimeout(filterArchive.timeout);
            filterArchive.timeout = setTimeout(function() {
                filterArchive.isCheckedBox = true;
                filterArchive.handleGetAjax();
            }, 350);
        },
        handleSearchInput: function(evt) {
            evt.preventDefault();
            $('#search-hidden-location-input').val('');
            filterArchive.isCheckedBox = false;
            var searchInput = $('#search-query');
            clearTimeout(filterArchive.timeout);
            let val = $(this).val()
            filterArchive.timeout = setTimeout(function() {
                if(val === '') {
                    let id = '';
                    filterArchive.filterGetListAjax(id);
                    $('.archive-search-dropdown').removeClass('is-active');
                } else {
                    filterArchive.handleGetAjax();
                }

            }, 350);
        },
        handleSearchInputBtn: function(evt) {
            evt.preventDefault();
            if(evt.data.msg === 'centre') {
                filterArchive.isNeedToGetOnlyAutocompleteResults = true;
            }
            clearTimeout(filterArchive.timeout);
            let val = $('#search-query').val();
            filterArchive.timeout = setTimeout(function() {
                if(val === '') {
                    let id = '';
                    filterArchive.filterGetListAjax(id);
                    $('.archive-search-dropdown').removeClass('is-active');
                } else {
                    filterArchive.handleGetAjax();
                }

            }, 350);

        },


        handleAutocomplete: function() {
            var id = $(this).attr('data-centre-id');
            $('.archive-search-dropdown-list').html('');
            $('.archive-search-dropdown').removeClass('is-active');
            if(filterArchive.isCentresPage) {
                filterArchive.filterGetListAjax(id);
            } else {
                window.location.href = window.location.origin + '/centres?center_id=' + id + '&qualification_ids='+SkillsForWales.post_id;
            }
        },

        /**
         * Handle the clear all button state.
         */
        handleClearAll: function() {
            var archiveClearAll = false;
            var clearAllButton = $('.clear-all');
            var sortBy = $('input[name="sort-by"]');
            filterArchive.archiveMultiSelects.push(sortBy);
            filterArchive.archiveMultiSelects.each(function() {
                var type = $(this).attr('data-type');
                var input = $('input[name="' + type + '_ids"]');
                var sortBy = $('input[name="sort-by"]:checked');
                var sortedBy = sortBy.is($(this));
                if (input.val() !== '' || sortedBy) {
                    archiveClearAll = true;
                }
                if (archiveClearAll === true) {
                    clearAllButton.addClass('active');
                } else {
                    clearAllButton.removeClass('active');
                }
            });
        },

        handleGetAjax: function() {
            //for centres page
            if(filterArchive.isCentresPage || filterArchive.isQulificationPage) {
                //var cardsUrl = $('#search-query').attr('data-url');
                if(!filterArchive.isCheckedBox) {
                   getAutocompleteListOrLocationId(filterArchive);
                } else {
                    if($('#search-query').val() === '') {
                        let id = '';
                        filterArchive.filterGetListAjax(id);
                    } else {
                        let id = getLocationID();
                        filterArchive.filterGetListAjax(id);
                    }

                }
            } else {
                var id = '';
                filterArchive.filterGetListAjax(id);
            }
            return false;
        },
        filterGetListAjax (id, qualificationIds) {
            if(filterArchive.isCentresPage) {
                $('.loading').addClass('is-active');
            }
            var qualifIds = $('#qualification_ids').val();
            if(qualificationIds) {
                var qualifIds = qualificationIds;
            }
            console.log('getting list');
            $.ajax({
                type: 'GET',
                url: SkillsForWales.ajax_url,
                dataType: 'html',
                data: {
                    'action': $('input[name="action"]').val(),
                    'post_type': SkillsForWales.post_type,
                    'level_ids': $('#level_ids').val(),
                    'sector_ids': $('#sector_ids').val(),
                    'category_ids': $('#category_ids').val(),
                    'qualification_ids': qualifIds,
                    'search_query': $('#search-query').val(),
                    'sort_by': $('input[name="sort-by"]:checked').val(),
                    'meta_key': $('input[name="meta_key"]').val(),
                    'meta_value': $('input[name="meta_value="]').val(),
                    'meta_compare': $('input[name="meta_compare"]').val(),
                    'center_id':id,

                },
                beforeSend: function() {
                    //multiSelect.closeMultiSelect();
                },
                success: function(data) {

                    var response = $.parseJSON(data);
                    var $data = $(response.data.content);

                    if(filterArchive.isCentresPage) {
                        $('.loading').removeClass('is-active');
                        if ($data.length > 0) {
                            $('.archive-search-dropdown-list').html();
                            $('.archive-search-dropdown-list').hide();
                            $('.section-centres').show();
                            hideNoContentContainer(filterArchive.archiveSectionContent,  filterArchive.archiveNoPosts);

                            renderNewContent($data, filterArchive.archiveSectionContent, filterArchive.archiveNoPosts, filterArchive.archiveSection)
                            showSearchResultAmount();
                            if($data.length <3) {
                                $('.card-item-container').addClass('is-flex-start');
                            } else {
                                $('.card-item-container').removeClass('is-flex-start');
                            }
                            var locations = getLocations();
                            filterArchive.centresMap.hideMarkers();
                            filterArchive.centresMap.drawMarkers(locations, filterArchive.centresMap.getMap());

                        } else {
                            $('.section-centres').hide();
                            showNoContentContainer(filterArchive.archiveSectionContent,  filterArchive.archiveNoPosts);
                            filterArchive.centresMap.hideMarkers();

                        }
                    } else {
                        filterArchive.archiveSection.attr('data-next-url', response.data.nextUrl || '')


                        if ($data.length) {
                            renderNewContent($data, filterArchive.archiveContent, filterArchive.archiveNoPosts, filterArchive.archiveSection );
                        } else {
                            showNoContentContainer(filterArchive.archiveContent, filterArchive.archiveNoPosts)
                        }
                    }



                },
                error: function(jqXHR, textStatus, errorThrown) {
                    console.log($.parseJSON(jqXHR.responseText) + ' :: ' + textStatus + ' :: ' + errorThrown);
                },
            });
        }




    };

    filterArchive.init();

});
